<div class="d-flex flex-column">
  <div class="d-flex">
    <div class="tab-group d-flex" [class.items-gap]="homePageStyles">
      @for (tab of tabs; track tab; let index = $index) {
        <div
          (click)="activateTab(tab, index)"
          [class.selected]="tab.selected"
          [attr.data-qa]="tab.testId"
          class="tab col text-center"
          [class.col]="fillSpaceItems()"
        >
          <div class="d-flex flex-row align-items-center">
            @if (tab.icon()) {
              <rx-icon [name]="tab.icon()" size="lg"></rx-icon>
            }
            <span [class.title]="hideLabelsOnMobile" [class.ml-2]="tab.icon()" [class.home__page]="homePageStyles">
              {{ tab.title }}
            </span>
          </div>
        </div>
      }
    </div>
    <div class="ml-auto tab-group d-flex">
      <ng-content select="[rigthSection]"></ng-content>
    </div>
  </div>
  <ng-content></ng-content>
</div>
